<template>
  <div id="exploration-builder">
    <div class="container">
      <router-link :to="{ name: 'Dashboard'}" class="btn btn-outline-primary btn-sm mb-2 mt-2"><i class="fal fa-arrow-left"></i> Dashboard</router-link>
      <form @submit.prevent>
        <!-- TITLE -->
        <div class="form-group">
          <label class="mt-2">Title</label>
          <input required v-model="exploration.title" class="form-control" />
        </div><!-- /.form-group -->
        <!-- SUBMIT BUTTON -->
        <button @click="saveExploration()" class="btn btn-outline-success">Save</button>
      </form>
    </div><!-- /.container -->
  </div><!-- /#exploration-builder -->
</template>

<script>
  import { mapState } from 'vuex'
  const fb = require('../firebaseConfig.js')

  export default {
    data() {
      return {
        exploration: {
          title: '',
          points: []
        },
        editMode: false
      }
    },
    computed: {
      ...mapState(['userProfile', 'currentUser'])
    },
    created() {
      this.editMode = false
      // Check to see if we are editing an existing exploration
      if (this.$route.params.id) {
        fb.explorationsCollection.doc(this.$route.params.id).get().then(doc => {
          this.exploration = doc.data()
          this.exploration.id = doc.id
        })
        this.editMode = true
      }
    },
    methods: {
      saveExploration() {
        if (this.editMode == false) {
          fb.explorationsCollection.add({
            createdOn: new Date(),
            title: this.exploration.title,
            userId: this.currentUser.uid,
            points: [],
            presentation: {
              point: 0
            }
          }).then(ref => {
            this.$router.push({name: 'Dashboard'})
          }).catch(err => {
            console.log(err)
          })
        } else {
          fb.explorationsCollection.doc(this.exploration.id).update({
            title: this.exploration.title
          }).then(ref => {
            this.$router.push({name: 'Dashboard'})
          }).catch(err => {
            console.log(err)
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ExplorationSettings.vue